enum CardProgramAccess {
  FOLLOW_PLATFORM = "FOLLOW_PLATFORM",
  DISABLED = "DISABLED",
}

export default CardProgramAccess;
